module.exports = __webpack_public_path__ + "img/traffic-navigation-icon.809cb62e.svg";